import React, { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import {
  CLIENT_EDIT_ACL,
  STATUS_CODE_200,
  TRANSACTION_LIMIT_EDIT,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomModal from "../../../../components/main_comps/custom_modal";
import AddSecurityDetailsModal from "./AddSecurityDetailsModal";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { useSelector } from "react-redux";
import { BiEditAlt } from "react-icons/bi";
import {
  colorBlack,
  colorWhite,
} from "../../../../../utility/constants/colorManager";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";
import ComissionContainer from "../../../../components/ui_comps/ComissionContainer";
import CheckBoxInput from "../../../../components/ui_comps/CheckBoxInput";
const Container = ({ title, value, style1, style2 }) => {
  return (
    <div
      style={{
        display: "flex",
        marginBottom: "20px",
        lineHeight: 2,
        justifyContent: "space-between",
      }}
    >
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
          ...style1,
        }}
      >
        {title}
      </p>
      <p
        style={{
          color: "#3A3A3A",
          fontSize: "14px",
          textTransform: "capitalize",
          ...style2,
        }}
      >
        {value}
      </p>
    </div>
  );
};

function TransactionLimits({ data, isEditClicked, onChange }) {
  const [amount, setAmount] = useState("");
  const [securityAmount, setSecurityAmount] = useState("");
  const [percentage, setPercentage] = useState("");
  const [currentId, setCurrentId] = useState(null);
  const [minTransactionVolume, setMinTransactionVolume] = useState("");
  const [maxTransactionVolume, setMaxTransactionVolume] = useState("");
  const [minTransactionValue, setMinTransactionValue] = useState("");
  const [maxTransactionValue, setMaxTransactionValue] = useState("");
  const [showTransLimit, setShowTransLimit] = useState(false);
  const [loading, setLoading] = useState("");
  const [openSecurityModal, setOpenSecurityModal] = useState(false);
  const [mainArray, setMainArray] = useState([]);
  const [edit, setEdit] = useState(false);
  const [isFinoMechanismCoupon, setIsFinoMechanismCoupon] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [openCouponModal, setOpenCouponModal] = useState(false);
  const [clientRate, setClientRate] = useState([]);
  const [flatData, setFlatData] = useState({});
  const [type, setType] = useState("");
  const [mechanism, setMechanism] = useState([]);
  const [isFinoPresent, setisFinoPresent] = useState(false);
  const [vpaSubString, setVpaSubString] = useState("");
  const [notifyUrl, setNotifyUrl] = useState("");
  const [mccCode, setMcccode] = useState("");
  const [allMechanismsPresent, setAllMechansimPresent] = useState(false);

  const styles = {
    inputStyle: {
      backgroundColor: "#F3F3F3",
      alignSelf: "center",
      height: 50,
      width: "100%",
      boxShadow: "none",
      outline: "none",
      paddingLeft: 10,
      borderRadius: 5,
      boxSizing: "border-box",
    },
    containerStyle: {
      padding: 0,
      height: 50,
      marginBottom: 20,
    },
    ioContainerStyle: {
      marginLeft: 20,
      display: "flex",
      position: "relative",
      flexDirection: "column",
      paddingTop: 20,
    },
  };
  const inputStyle = {
    maxWidth: 500,
    minWidth: 250,
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    width: 350,
  };
  const containerStyle = {
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: 40,
    border: "1px solid #CBCACA",
    borderRadius: "5px",
  };

  function handleInputChange(value, index, e, name) {
    let updatedArray = mainArray;

    const newValue = {
      service_type: e.service_type,
      serviceProviderName: e.serviceProviderName,
      program_id: e.program_id,
      ...updatedArray[index],
      [name]: value,
    };

    updatedArray[index] = {
      ...newValue,
    };

    setMainArray([...updatedArray]);
  }

  const updateTransactionLimit = (data1) => {
    ApiRequestPost.updateTransactionLimit({
      clientId: data?.userId,
      programs: data1?.programs,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });

          navigate("/clients");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setMainArray([]);
        setLoading(false);
      });
  };

  const onClickAddPrograms = () => {
    ApiRequestPost.addPrograms({
      clientId: data?.userId,
      comissionRate: type === "FLAT" ? [flatData] : clientRate,
      mechanism: mechanism[0],
      comissionType: type,
      vpaSubstring: vpaSubString,
      mcc: mccCode,
      notifyUrl: notifyUrl,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          setOpenCouponModal(false);
          navigate("/clients");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setMainArray([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    // if (data?.rollbackReserves?.status) {
    //   onChange({ reservePercentage: amount });
    // } else if (data?.security.status) {
    //   onChange({ securityAmount: amount });
    onChange({
      securityAmount: custom_getvalue(securityAmount, data?.security?.amount),
      reserveAmount: custom_getvalue(amount, data?.rollbackReserves?.amount),
    });
  }, [securityAmount, amount]);
  useEffect(() => {
    setAmount(data?.rollbackReserves?.amount / 100);
    setPercentage(data?.rollbackReserves?.percentage);
    setSecurityAmount(data?.security?.amount / 100);
  }, [isEditClicked]);

  useEffect(() => {
    let obj = data.programs.find(
      (ob) =>
        ob.service_type?.toUpperCase() === "PAYIN" ||
        ob.service_type?.toUpperCase() === "PAYOUT" ||
        ob.service_type?.toUpperCase() === "VOUCHER"
    );

    if (obj) {
      setShowTransLimit(true);
    } else setShowTransLimit(false);

    const hasCoupon = data.programs.some(
      (program) => program.mechanism === "coupon"
    );
    const hasVbaOrQr = data.programs.some((program) =>
      ["vba", "qr"].includes(program.mechanism)
    );

    if (obj?.serviceProviderName?.toUpperCase() === "FINO") {
      setisFinoPresent(true);
    }
    if (
      obj?.serviceProviderName?.toUpperCase() === "FINO" &&
      obj?.mechanism?.toUpperCase() === "COUPON"
    ) {
      setIsFinoMechanismCoupon(true);
    }
  }, [data]);

  return (
    <div style={{ marginLeft: 20 }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {data?.rollbackReserves?.status && (
          <div style={{ marginRight: "5%" }}>
            <p style={{ color: "#000000", margin: "15px 0px" }}>
              <>
                Rolling reserve{" "}
                <span style={{ color: "#6C6B6B" }}>{percentage}%</span>
              </>
            </p>
            <div
              style={{
                display: "flex",
                background: "#F6F6F6",
                borderRadius: "4px",
                fontSize: "15px",
                width: "350px",
                color: "#1E2234",
                height: 45,
                alignItems: "center",
                border: "1px solid #DFDFDF",
                padding: "10px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ textAlign: "left" }}>{"₹"}</div>
              <CustomInput
                validator={"number"}
                onChange={(e) => {
                  setAmount(e);
                }}
                value={amount}
                type={"input"}
                placeholder={"Enter Amount"}
                inputStyles={{
                  border: "1px solid #F6F6F6",
                  background: "#F6F6F6",
                  fontSize: "15px",
                  color: "#1E2234",
                  boxShadow: null,
                }}
                disabled={!isEditClicked}
              />
            </div>
          </div>
        )}

        {data?.security?.status && (
          <div>
            <p style={{ color: "#000000", margin: "15px 0px" }}>
              Security Deposit
            </p>

            <div
              style={{
                display: "flex",
                background: "#F6F6F6",
                borderRadius: "4px",
                fontSize: "15px",
                width: "350px",
                color: "#1E2234",
                height: 45,
                alignItems: "center",
                border: "1px solid #DFDFDF",
                padding: "10px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ textAlign: "left" }}>{"₹"}</div>
              <CustomInput
                validator={"number"}
                onChange={(e) => {
                  setSecurityAmount(e);
                }}
                value={securityAmount}
                type={"input"}
                placeholder={"Security Deposit"}
                inputStyles={{
                  border: "1px solid #F6F6F6",
                  background: "#F6F6F6",
                  fontSize: "15px",
                  color: "#1E2234",
                  boxShadow: null,
                }}
                disabled={!isEditClicked}
              />
            </div>
          </div>
        )}

        {data?.security?.status && (
          <div style={{ marginLeft: "5%" }}>
            <p style={{ color: "#000000", margin: "15px 0px" }}>
              Charge Back Amount
            </p>

            <div
              style={{
                display: "flex",
                background: "#F6F6F6",
                borderRadius: "4px",
                fontSize: "12px",
                width: "350px",
                color: "#1E2234",
                height: 45,
                alignItems: "center",
                border: "1px solid #DFDFDF",
                padding: "10px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ textAlign: "left" }}>Charge Back Hold</div>
              <CustomInput
                validator={"number"}
                // onChange={(e) => {
                //   setSecurityAmount(e);
                // }}
                value={`₹${data?.chargeBackHold}`}
                type={"input"}
                placeholder={"Security Deposit"}
                inputStyles={{
                  border: "1px solid #F6F6F6",
                  background: "#F6F6F6",
                  fontSize: "15px",
                  color: "#1E2234",
                  boxShadow: null,
                }}
                disabled
              />

            </div>
            <div
              style={{
                display: "flex",
                background: "#F6F6F6",
                borderRadius: "4px",
                fontSize: "12px",
                width: "350px",
                color: "#1E2234",
                height: 45,
                alignItems: "center",
                border: "1px solid #DFDFDF",
                padding: "10px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ textAlign: "left" }}>Charge Back Release</div>
              <CustomInput
                validator={"number"}
                // onChange={(e) => {
                //   setSecurityAmount(e);
                // }}
                value={`₹${data?.chargeBackRelease}`}
                type={"input"}
                placeholder={"Security Deposit"}
                inputStyles={{
                  border: "1px solid #F6F6F6",
                  background: "#F6F6F6",
                  fontSize: "15px",
                  color: "#1E2234",
                  boxShadow: null,
                }}
                disabled
              />

            </div>
          </div>
        )}
      </div>

      {
        !data?.security?.status && !data?.rollbackReserves?.status && (
          <div>
            <p style={{ color: "#001777", fontSize: "16px", fontWeight: "500" }}>
              Add Rolling Reserve or Security Deposit
            </p>
            <CustomButton
              title={"Add"}
              styles={{ height: 35, marginTop: 15 }}
              onClick={() => {
                setOpenSecurityModal(true);
              }}
            />
          </div>
        )
      }

      <div style={styles.ioContainerStyle}>
        {edit ? (
          <div>
            <div style={{ display: "flex" }}>
              {data?.programs
                ?.filter(
                  (e) =>
                    !(
                      e.serviceProviderName === "Equitas" &&
                      e.service_type === "van"
                    )
                )
                ?.map((e, i) => (
                  <div
                    style={{
                      marginTop: 50,
                      width: 400,
                      marginRight: "10%",
                      border: "1px solid #E2E2E2",
                      borderRadius: "12px",
                      padding: "30px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#FFD596",
                        padding: "10px 0px 10px 25px",
                        borderRadius: 5,
                      }}
                    >
                      {/* {e.serviceProviderName !== "Equitas" &&
                        e.service_type !== "van" && ( */}
                      <>{`${e.serviceProviderName} (${e.service_type})`}</>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        height: "100%",
                      }}
                    >
                      <CustomInput
                        validator="number"
                        placeholder="Min Transaction Volume"
                        onChange={(data) => {
                          setMinTransactionVolume(data);
                          handleInputChange(data, i, e, "minTransactionVolume");
                        }}
                        value={mainArray[i]?.minTransactionVolume || ""}
                        inputcomponentStyles={{ ...styles.inputStyle }}
                        type="input"
                        inputStyles={{
                          ...styles.containerStyle,
                        }}
                      />
                      <CustomInput
                        validator={"number"}
                        onChange={(data) => {
                          setMaxTransactionVolume(data);
                          handleInputChange(data, i, e, "maxTransactionVolume");
                          // updateMainArray("maxTransactionVolume", data, i);
                        }}
                        placeholder="Max Transaction Volume"
                        value={mainArray[i]?.maxTransactionVolume || ""}
                        inputcomponentStyles={{ ...styles.inputStyle }}
                        type="input"
                        inputStyles={{
                          ...styles.containerStyle,
                        }}
                        maxLength={9}
                      />
                      <CustomInput
                        validator="number"
                        onChange={(data) => {
                          setMinTransactionValue(data);
                          handleInputChange(data, i, e, "minTransactionAmt");
                          // updateMainArray("minTransactionAmt", data, i);
                        }}
                        value={mainArray[i]?.minTransactionAmt || ""}
                        placeholder="Min Transaction Value"
                        inputcomponentStyles={{ ...styles.inputStyle }}
                        type="input"
                        inputStyles={{
                          ...styles.containerStyle,
                        }}
                      />
                      <CustomInput
                        validator="number"
                        placeholder="Max Transaction Value"
                        inputcomponentStyles={{ ...styles.inputStyle }}
                        type="input"
                        onChange={(data) => {
                          setMaxTransactionValue(data);
                          handleInputChange(data, i, e, "maxTransactionAmt");
                          // updateMainArray("maxTransactionAmt", data, i);
                        }}
                        value={mainArray[i]?.maxTransactionAmt || ""}
                        inputStyles={{
                          ...styles.containerStyle,
                        }}
                      />
                    </div>
                  </div>
                ))}
            </div>
            {edit && (
              <div
                style={{
                  display: "flex",
                  marginLeft: "38%",
                  marginRight: "10%",
                  marginTop: "25px",
                  gap: "25px",
                  marginBottom: "10px",
                  position: "absolute",
                  right: "0px",
                  top: "0px",
                }}
              >
                <CustomButton
                  title="Cancel"
                  styles={{
                    backgroundColor: colorWhite,
                    border: "1px solid black",
                  }}
                  textStyles={{
                    color: colorBlack,
                  }}
                  onClick={() => {
                    setEdit(false);
                    setCurrentId(null);
                  }}
                />
                <CustomButton
                  title={"Save"}
                  textStyles={{
                    color: isEditClicked ? "#fff" : "white",
                  }}
                  onClick={() => {
                    updateTransactionLimit({
                      programs: mainArray,
                    });
                  }}
                />
              </div>
            )}
          </div>
        ) : !edit ? (
          <div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "row",
                position: "relative",
              }}
            >
              {data?.programs
                ?.filter(
                  (e) =>
                    !(
                      e.serviceProviderName === "Equitas" &&
                      e.service_type === "van"
                    )
                )
                ?.map((e, i) => (
                  <div
                    style={{
                      marginTop: 50,
                      width: 400,
                      marginRight: "10%",
                      border: "1px solid #E2E2E2",
                      borderRadius: "12px",
                      padding: "30px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#FFD596",
                        padding: "10px 0px 10px 25px",
                        borderRadius: 5,
                      }}
                    >
                      {`${e.serviceProviderName} (${e.service_type})`}
                    </div>
                    <Container
                      title="Min Transaction Volume"
                      value={`₹ ${e?.minTransactionVolume === undefined
                        ? "0"
                        : e?.minTransactionVolume / 100
                        }`}
                    />
                    <Container
                      title="Max Transaction Volume"
                      value={`₹ ${e?.maxTransactionVolume === undefined
                        ? "0"
                        : e?.maxTransactionVolume / 100
                        }`}
                    />
                    <Container
                      title="Min Transaction Value"
                      value={`₹ ${e?.minTransactionAmt === undefined
                        ? "0"
                        : e?.minTransactionAmt / 100
                        }`}
                    />
                    <Container
                      title="Max Transaction Value"
                      value={`₹ ${e?.maxTransactionAmt === undefined
                        ? "0"
                        : e?.maxTransactionAmt / 100
                        }`}
                    />
                  </div>
                ))}
            </div>
            <div>
              {!edit &&
                showTransLimit &&
                aclData?.includes(CLIENT_EDIT_ACL) &&
                aclData?.includes(TRANSACTION_LIMIT_EDIT) && (
                  <div
                    style={{
                      marginLeft: "38%",
                      marginRight: "10%",
                      marginTop: "20px",
                      marginBottom: "10px",
                      position: "absolute",
                      right: "0px",
                      top: "0px",
                    }}
                  >
                    <CustomButton
                      ionDirection="left"
                      icon={<BiEditAlt size={16} color="white" />}
                      title={"Edit"}
                      textStyles={{
                        color: isEditClicked ? "#fff" : "white",
                      }}
                      onClick={() => {
                        setEdit(true);
                        // setCurrentId(i);
                        // setColor(true);
                      }}
                    />{" "}
                  </div>
                )}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {openSecurityModal && (
        <CustomModal
          headerTitle="Add Rolling Reserve or Security Deposit"
          open={openSecurityModal}
          onClose={() => {
            setOpenSecurityModal(false);
          }}
          containerStyle={{
            width: "400px",
            height: "auto ",
          }}
        >
          <AddSecurityDetailsModal
            onClickCancel={() => setOpenSecurityModal(false)}
            data={data}
          />
        </CustomModal>
      )}
      {openCouponModal && (
        <CustomModal
          headerTitle="Add Client rate"
          open={openCouponModal}
          onClose={() => {
            setOpenCouponModal(false);
          }}
          containerStyle={{
            width: "400px",
            height: "auto ",
          }}
        >
          <div style={{ minWidth: "150px" }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>Client Rate</label>
            <ComissionContainer
              styles={{
                width: "343px",
                background: "white",
                minHeight: "71px",
                borderRadius: "6px",
                border: "1px solid #CBCACA",
              }}
              innerStyles={{
                marginLeft: "-12px",
                marginTop: "-8px",
              }}
              onClickNext={(data, flatData, type) => {
                if (data.length > 0) {
                  setClientRate(data);
                }
                if (flatData) {
                  setFlatData(flatData);
                }
                if (type) {
                  setType(type?.toUpperCase());
                }
              }}
              isSlabRequired={true}
            />
          </div>
          <div style={{}}>
            {isFinoMechanismCoupon && (
              <>
                <div style={{ minWidth: "150px", margin: "10px 0 10px" }}>
                  <label style={{ fontSize: 14, lineHeight: 2 }}>
                    Vpa Sub String
                  </label>
                  <CustomInput
                    onChange={(data) => {
                      setVpaSubString(data);
                    }}
                    value={vpaSubString}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Vpa Substring"
                    validator={"alphaNum2"}
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                    maxLength={20}
                  />
                </div>
                <div style={{ minWidth: "150px" }}>
                  <label style={{ fontSize: 14, lineHeight: 2 }}>
                    MCC code
                  </label>
                  <CustomInput
                    onChange={(data) => {
                      setMcccode(data);
                    }}
                    value={mccCode}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="MCC code"
                    validator="mcc"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
                <div style={{ minWidth: "150px" }}>
                  <label style={{ fontSize: 14, lineHeight: 2 }}>
                    Notify Url
                  </label>
                  <CustomInput
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Notify Url"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                    value={notifyUrl}
                    onChange={(data) => {
                      setNotifyUrl(data);
                    }}
                  />
                </div>
                <div style={{ display: "flex" }}>
                  <CheckBoxInput
                    title="VBA"
                    value={"vba"}
                    defaultChecked={mechanism?.includes("vba")}
                    onChange={(val) => {
                      if (mechanism?.includes("vba")) {
                        let arr = mechanism?.filter((o) => o !== "vba");
                        setMechanism(arr);
                      } else {
                        setMechanism([...mechanism, val.target.value]);
                      }
                    }}
                  />
                  <CheckBoxInput
                    title="QR"
                    value={"qr"}
                    defaultChecked={mechanism?.includes("qr")}
                    onChange={(val) => {
                      if (mechanism?.includes("qr")) {
                        let arr = mechanism?.filter((o) => o !== "qr");
                        setMechanism(arr);
                      } else {
                        setMechanism([...mechanism, val.target.value]);
                      }
                    }}
                  />
                </div>
              </>
            )}
            {!isFinoMechanismCoupon && (
              <CheckBoxInput
                title="COUPON"
                value={"coupon"}
                defaultChecked={mechanism?.includes("coupon")}
                onChange={(val) => {
                  if (mechanism?.includes("coupon")) {
                    let arr = mechanism?.filter((o) => o !== "coupon");
                    setMechanism(arr);
                  } else {
                    setMechanism([...mechanism, val.target.value]);
                  }
                }}
              />
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginTop: "20px",
            }}
          >
            <CustomButton
              title="Cancel"
              styles={{ background: "white" }}
              textStyles={{
                color: "#38369C",
                fontWeight: "500",
                fontSize: "16px",
              }}
              onClick={() => {
                setOpenCouponModal(false);
              }}
            />
            <CustomButton
              title="Submit"
              styles={{ background: "#38369C" }}
              textStyles={{
                color: "#FDFDFD",
                fontWeight: "500",
                fontSize: "16px",
              }}
              onClick={() => {
                const exp = /^\d{1,2}(?:\.\d{1,2})?$/;
                if (type?.toUpperCase() === "FLAT") {
                  if (flatData?.value === "" || flatData?.type === undefined) {
                    enqueueSnackbar("Please fill all fields", {
                      variant: "error",
                    });
                    return;
                  }
                  if (!exp.test(flatData?.value)) {
                    enqueueSnackbar("Please add appropriate value", {
                      variant: "error",
                    });
                    return;
                  }
                }
                if (type?.toUpperCase() === "SLAB") {
                  if (clientRate.length === 0) {
                    enqueueSnackbar("Please fill all fields", {
                      variant: "error",
                    });
                    return;
                  }

                  for (const slabValues of clientRate) {
                    if (
                      slabValues?.value === "" ||
                      slabValues?.from === "" ||
                      slabValues?.to === ""
                    ) {
                      enqueueSnackbar("Please fill all fields", {
                        variant: "error",
                      });
                      return;
                    }
                    if (!exp.test(slabValues?.value)) {
                      enqueueSnackbar("Please add appropriate value", {
                        variant: "error",
                      });
                      return;
                    }
                  }
                }
                if (mechanism.length === 0) {
                  enqueueSnackbar("Please select Mechansim", {
                    variant: "error",
                  });
                  return;
                }
                if (mechanism.length === 2) {
                  enqueueSnackbar("Please select one Mechansim", {
                    variant: "error",
                  });
                  return;
                }
                if (mechanism[0] === "vba" || mechanism[0] === "qr") {
                  if (vpaSubString === undefined || vpaSubString.length === 0) {
                    enqueueSnackbar("Please Enter valid vpaSubString ", {
                      variant: "error",
                    });
                    return;
                  }
                  if (mccCode === undefined || mccCode.length < 4) {
                    enqueueSnackbar("Please Enter valid MCC", {
                      variant: "error",
                    });
                    return;
                  }
                  if (notifyUrl === undefined || notifyUrl.length === 0) {
                    enqueueSnackbar("Please Enter valid NotifyUrl", {
                      variant: "error",
                    });
                    return;
                  }
                }

                onClickAddPrograms();
              }}
            />
          </div>
        </CustomModal>
      )
      }
    </div >
  );
}

export default TransactionLimits;
